<template>
  <div>
    <b-card>
    <div style="position:relative;overflow:hidden;">
      <a
          href="https://yandex.uz/maps/10335/tashkent/?utm_medium=mapframe&utm_source=maps"
          style="color:#eee;
          font-size:12px;
          position:absolute;
          top:0px;">
        Ташкент
      </a>
      <a
          href="https://yandex.uz/maps/10335/tashkent/?ll=69.279737%2C41.311151&utm_medium=mapframe&utm_source=maps&z=12"
          style="color:#eee;
          font-size:12px;
          position:absolute;
          top:14px;">
        Ташкент — Яндекс.Карты
      </a>
      <iframe
          src="https://yandex.uz/map-widget/v1/-/CCtA5~r"
          width="800"
          height="600"
          frameborder="1"
          allowfullscreen="true"
          style="position:relative;">
      </iframe>
    </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Map",
  data() {
    return {

    };
  },

  mounted() {
    this.locateGeoLocation();
  },

  methods: {
    initMarker(loc) {
      this.existingPlace = loc;
    },
    addLocationMarker() {
      if (this.existingPlace) {
        const marker = {
          lat: this.existingPlace.geometry.location.lat(),
          lng: this.existingPlace.geometry.location.lng()
        };
        this.locationMarkers.push({ position: marker });
        this.locPlaces.push(this.existingPlace);
        this.center = marker;
        this.existingPlace = null;
      }
    },
    locateGeoLocation: function() {
      navigator.geolocation.getCurrentPosition(res => {
        this.center = {
          lat: res.coords.latitude,
          lng: res.coords.longitude
        };
      });
    }
  }
};
</script>
